import {
    IdentificationReliabilityControllerApi,
    Psd2LimitsConfigControllerApi,
    Configuration,
    IdentificationReliabilityConfig,
    Psd2LimitsConfig,
} from 'kent-identyum-service-api';
import Cookies from 'universal-cookie/es6';
import { AppSettings } from '../common/app-settings';

const apiConfiguration = (): Configuration => {
    const cookies = new Cookies();
    const token = cookies.get(AppSettings.ACCESS_TOKEN_OBJECT_COOKIE);
    return new Configuration({ accessToken: token.accessToken, basePath: process.env.REACT_APP_IDENTYUM_SERVICE });
};

const IdentificationReliabilityControllerClient = (): IdentificationReliabilityControllerApi =>
    new IdentificationReliabilityControllerApi(apiConfiguration());

const Psd2LimitsConfigControllerClient = (): Psd2LimitsConfigControllerApi =>
    new Psd2LimitsConfigControllerApi(apiConfiguration());

export const getIdentificationReliabilityConfig = async (): Promise<IdentificationReliabilityConfig> => {
    return IdentificationReliabilityControllerClient()
        .getConfig()
        .then((response) => response.data)
        .catch((error) => {
            throw error;
        });
};

export const putIdentificationReliabilityConfig = async (
    identificationReliabilityConfig: IdentificationReliabilityConfig
): Promise<IdentificationReliabilityConfig> => {
    return IdentificationReliabilityControllerClient()
        .updateConfig(identificationReliabilityConfig)
        .then((response) => response.data)
        .catch((error) => {
            throw error;
        });
};

export const getPsd2LimitsConfig = async (): Promise<Psd2LimitsConfig> => {
    return Psd2LimitsConfigControllerClient()
        .getLimitsConfig()
        .then((response) => response.data)
        .catch((error) => {
            throw error;
        });
};

export const putPsd2LimitsConfig = async (config: Psd2LimitsConfig): Promise<Psd2LimitsConfig> => {
    return Psd2LimitsConfigControllerClient()
        .updateLimitsConfig(config)
        .then((response) => response.data)
        .catch((error) => {
            throw error;
        });
};
